export default "__VITE_ASSET__FjDPznDj__"